<div
  layout
  layout-full-width
  [attr.padding-tb-small-xxx]="noPadding() ? null : ''"
  class="container"
  [attr.padding-lr]="noPadding() ? null : ''"
>
  <div class="label" [attr.padding-tb-small-xx]="noPadding() ? null : ''">
    {{ name() }}
  </div>
  <div
    class="value"
    layout-horizontal
    overflow-hidden
    [attr.padding-tb-small-xxx]="noPadding() ? null : ''"
  >
    <div layout-full-width>
      <div class="row" layout-horizontal layout-align-items-center>
        <ng-container *ngTemplateOutlet="fieldDisplayTpl()!; context: { value: value() }" />
      </div>
    </div>
  </div>
</div>
